import { render } from "./vcouponinfo.vue?vue&type=template&id=aba31438&scoped=true"
import script from "./vcouponinfo.vue?vue&type=script&lang=js"
export * from "./vcouponinfo.vue?vue&type=script&lang=js"

import "./vcouponinfo.vue?vue&type=style&index=0&id=aba31438&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境商户后台shop.jsyinba.com/jsmerchant/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aba31438"]])

export default __exports__